import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { ButtonLink } from 'src/components/Link';
import RichText from 'src/components/rich_text/RichText';
import { FieldHotspotsMarker } from '../types';

export const HotspotContent: React.FC<{
  hotspot: FieldHotspotsMarker;
}> = ({ hotspot }) => {
  const { name: title, field_text: text, field_link: link } = hotspot;
  const image = hotspot.relationships.field_media.relationships.field_media_image.gatsbyImage;

  return (
    <div>
      <GatsbyImage
        className="pds-rounded-lg"
        alt=""
        aria-hidden="true"
        objectFit="contain"
        image={image}
      />
      <h3 className="pds-mt-4 pds-text-title-md">{title}</h3>
      <div className="pds-mt-3">
        <RichText body={text?.processed ?? ''} />
      </div>
      {link && link.url && (
        <ButtonLink buttonColor="neutral" className="pds-mt-5" to={link?.url}>
          {link?.title}
        </ButtonLink>
      )}
    </div>
  );
};
